import { render, staticRenderFns } from "./HistoricalChannelSupplierCount.vue?vue&type=template&id=8bc61d7c&"
import script from "./HistoricalChannelSupplierCount.vue?vue&type=script&lang=ts&"
export * from "./HistoricalChannelSupplierCount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HistoricalChannelSupplierCount.vue"
export default component.exports